import * as Yup from "yup";

const BannerValidationSchema = Yup.object({
  name: Yup.string().required("Name is required"),

  image: Yup.string().required("Image URL is required"),

  stateId: Yup.string().required("State is required"),

  isNational: Yup.boolean().required("isNational is required"),
  active: Yup.boolean().required("Active is required"),
});

const faqValidationSchema = Yup.object({
  category: Yup.string().required("Category is required"),

  question: Yup.string().required("Question is required"),

  answer: Yup.string().required("Answer is required"),

  page: Yup.string().required("Page is required"),

  displayOrder: Yup.number().required("Display Order is required"),

  active: Yup.boolean().required("Active is required"),
});

const testimonialsValidationSchema = Yup.object().shape({
  imageUrl: Yup.string().required("First name is required"),

  firstName: Yup.string().required("First name is required"),

  lastName: Yup.string().required("Last name is required"),

  content: Yup.string().required("Content is required"),
  stateId: Yup.string().required("State is required"),

  universityId: Yup.string().required("University is required"),
  courseId: Yup.string().required("Course is required"),

  professions: Yup.array().required("Professions are required"),

  displayOrder: Yup.number().required("Display order is required"),

  active: Yup.boolean().required("Active status is required"),
});
const NotificationValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  message: Yup.string().required("Message is required"),
  targetType: Yup.string().required("Target type is required"),
  userIds: Yup.array().notRequired(), // userIds is no longer required
  image: Yup.string().notRequired(), // Image is optional
  notification_search: Yup.string().notRequired(),
  universityId: Yup.string().notRequired(),
  universityIds: Yup.array().notRequired(),
  courseId: Yup.string().notRequired(),
  regulationIds: Yup.array().notRequired(),
  semesterId: Yup.string().notRequired(),
  semesterIds: Yup.array().notRequired(),
  purchaseStatus: Yup.string().notRequired(),
});
const subscriptionValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),

  price: Yup.number()
    .typeError("Price must be a number")
    .required("Price is required"),

  actualPrice: Yup.number()
    .typeError("Actual Price must be a number")
    .required("Actual Price is required"),

  mentorshipSessions: Yup.number()
    .typeError("Mentorship sessions must be a number")
    .required("Mentorship sessions are required"),

  subjectsIncluded: Yup.number()
    .typeError("Mentorship sessions must be a number")
    .required("Subjects included is required"),

  displayOrder: Yup.number()
    .typeError("Display order must be a number")
    .required("Display order is required"),

  courseId: Yup.array()
    .min(1, "Course is required")
    .required("Course is required"),

  deviceType: Yup.string().required("Device type is required"),

  active: Yup.boolean().required("Status is required"),
});
const UserPurchasesValidationSchema = Yup.object({
  userId: Yup.string().required("User ID is required"),

  bookIds: Yup.array()
    .of(Yup.number())
    .min(1, "Book selection is required")
    .required("Book selection is required"),

  orderId: Yup.string().required("Order ID is required"),

  purchaseDate: Yup.date().required("Purchase date is required"),

  expiryDate: Yup.date().required("Expiry date is required"),
  active: Yup.string().required("Active status is required"),
});
const EditUserPurchasesValidationSchema = Yup.object({
  userId: Yup.string().required("User ID is required"),
  purchaseId: Yup.string().required("User ID is required"),

  bookId: Yup.number()
    .min(1, "Book selection is required")
    .required("Book selection is required"),
});

const collegeSchema = Yup.object().shape({
  name: Yup.string().trim().required("College name is required"),

  universityId: Yup.string().required("University is required"),

  address: Yup.string().trim().required("Address is required"),

  active: Yup.string().required("Status is required"),
});
const collegeCourseSchema = Yup.object().shape({
  collegeId: Yup.string().trim().required("College id is required"),

  courseId: Yup.string().required("Course id is required"),

  intakes: Yup.string().trim(),

  active: Yup.string().required("Status is required"),
});
const BannerCourseMappingValidationSchema = (isPopup) =>
  Yup.object().shape({
    [isPopup ? "popupId" : "bannerId"]: Yup.string()
      .trim()
      .required(`${isPopup ? "Popup" : "Banner"} id is required`),

    courseIds: Yup.array()
      .min(1, "At least one course is required")
      .required("Course ids are required"),

    active: Yup.string().required("Status is required"),
  });
const POPupvalidationSchema = Yup.object({
  head: Yup.string().required("Head is required"),

  text: Yup.string().required("Text is required"),

  image: Yup.string().required("Image is required"),

  link: Yup.string().required("Link is required"),

  whatsappNumber: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Enter valid WhatsApp number")
    .required("WhatsApp number is required"),

  phoneNumber: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Enter valid phone number")
    .required("Phone number is required"),

  active: Yup.boolean().required("Status is required"),
});
const AdvertisementsValidationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),

  image: Yup.string().required("Image is required"),

  link: Yup.string().nullable(),

  active: Yup.string().required("Status is required"),

  priority: Yup.number().required("Priority is required"),

  adId: Yup.string().trim(),
});
const AdvertisementMappingValidationSchema = Yup.object({
  adId: Yup.string().trim().required("Ad ID is required"),
  courseIds: Yup.array()
    .min(1, "At least one course is required")
    .required("Course ids are required"),
  screenIds: Yup.array()
    .min(1, "At least one screen is required")
    .required("Screen is required"),
  active: Yup.string().required("Status is required"),
});
export default {
  BannerValidationSchema,
  BannerCourseMappingValidationSchema,
  faqValidationSchema,
  testimonialsValidationSchema,
  NotificationValidationSchema,
  subscriptionValidationSchema,
  UserPurchasesValidationSchema,
  EditUserPurchasesValidationSchema,
  collegeSchema,
  collegeCourseSchema,
  POPupvalidationSchema,
  AdvertisementsValidationSchema,
  AdvertisementMappingValidationSchema,
};
